<div class="modal-xs">
  <div class="modal-body confirmation-dialog__body">
    <p class="title-m confirmation-dialog__title">
      {{ titleMessage | translate: { customValue: titleValue } }}
    </p>
    @if (!innerHTML) {
      <p class="default-s confirmation-dialog__message">
        {{ message | translate: { customValue: messageValue } }}
      </p>
    } @else {
      <p
        class="default-s confirmation-dialog__message"
        [innerHTML]="message | translate: { customValue: messageValue }"
      ></p>
    }
  </div>

  <div class="modal-footer confirmation-dialog__footer">
    @if (!acknowledge) {
      <button im-button class="inverted" (click)="cancelAction()">
        {{ cancelButtonMessage | translate }}
      </button>
    }
    <button im-button class="primary" [class.ms-auto]="acknowledge" (click)="okAction()">
      {{ okButtonMessage | translate }}
    </button>
  </div>
</div>
